import { useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";

export function ErrorPage() {
  const error = useRouteError() as Error;
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return <div>404 Not Found</div>;
}
